import { Button, type ButtonProps } from "@/components/ui/button";
import { steamLoginUrl } from "@/lib/api";

export function SteamSignInButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      onClick={(e) => {
        props.onClick?.(e);
        if (!e.defaultPrevented) {
          window.location.href = steamLoginUrl;
        }
      }}
    >
      <SteamLogo />
      Sign in through Steam
    </Button>
  );
}

function SteamLogo() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-2.2 13.4a2.4 2.4 0 0 1-3.36-1l-2.16-.86A4.41 4.41 0 0 0 8.5 16.7a4.4 4.4 0 0 0 4.16-2.93L15.5 11.7a3.4 3.4 0 1 0-3.4-3.4l-2.65 1.93c-.36-.16-.74-.24-1.13-.24-.55 0-1.07.13-1.53.36l4 1.6a2.4 2.4 0 0 1-1 4.45ZM15.5 9.9a2.05 2.05 0 1 1 0-4.1 2.05 2.05 0 0 1 0 4.1Z" />
    </svg>
  );
}
